module.exports = __webpack_public_path__ + "static/img/mr.a46829f1.svg";